document.addEventListener("DOMContentLoaded", async () => {
    // console.log("this is popup block 1.5sec wait run 25");

    function createpopup(locationarr, locationPopupstyle, locationSelectionType, locationPopupHeader, locationPopupDescription, savedLocationId) {
        const overlay = document.createElement("div");
        overlay.id = "multiloca-popup-overlay";
        document.body.appendChild(overlay);

        const locationPopup = document.createElement("div");
        if (locationPopupstyle === 'list') {
            locationPopup.classList.add("vertical-list-popup");
        }
        locationPopup.id = "multiloca-locationPopup";
        document.body.appendChild(locationPopup);

        const popupHeader = document.createElement("div");
        popupHeader.className = "multiloca-popup-header";
        popupHeader.innerHTML = locationPopupHeader;
        locationPopup.appendChild(popupHeader);

        const closePopup = document.createElement("span");
        closePopup.id = "multiloca-closePopup";
        closePopup.classList.add("close-popup-button");
        closePopup.innerHTML = "&#10005;";
        popupHeader.appendChild(closePopup);

        const popupContent = document.createElement("div");
        popupContent.className = "multiloca-popup-content";
        locationPopup.appendChild(popupContent);
        const buttonContainer = document.createElement("div");
        buttonContainer.className = "button-container";
        buttonContainer.style.padding = "10px";
        locationPopup.appendChild(buttonContainer);
        const shopNowButton = document.createElement("button");
        shopNowButton.className = "button btn shopNowButton";
        shopNowButton.innerHTML = "Jetzt shoppen";
        shopNowButton.style.width = "100%";
        buttonContainer.appendChild(shopNowButton);

        const descriptionpopup = document.createElement("div");
        descriptionpopup.className = "popup-description";
        descriptionpopup.innerHTML = locationPopupDescription;
        popupContent.appendChild(descriptionpopup);

        // Create back button for step 2 (will be shown/hidden based on step)
        const backButton = document.createElement("a");
        backButton.className = "popup-back-button";
        backButton.innerHTML = "← Back";
        backButton.style.cssText = "text-decoration: underline;cursor: pointer; font-size: 14px; display: none;";
        popupContent.appendChild(backButton);

        let locationContainer;
        if (locationPopupstyle === "dropdown") {
            locationContainer = document.createElement("select");
            locationContainer.className = "multiloca-popup-location-dropdown-popup";
            locationContainer.id = "locationDropDown";
            locationContainer.innerHTML = "<option value=''>WÄHLE DEINEN STANDORT</option>";
        }
        if (locationPopupstyle === "cards") {
            locationContainer = document.createElement("div");
            locationContainer.className = "multiloca-popup-location-grid";
        }
        if (locationPopupstyle === 'list') {
            locationContainer = document.createElement("div");
            locationContainer.className = "multiloca-popup-location-list";
            
        }
        if (locationPopupstyle === 'inline-list') {
            locationContainer = document.createElement("div");
            locationContainer.className = "multiloca-popup-location-inline";
        }

        let shopName = window.Shopify?.shop || window.location.hostname;

        if (shopName === 'feuerwerks.myshopify.com') {
            // Hide description in step 1
            descriptionpopup.style.display = "none";
            locationContainer.style.display = "none";

            // Stepwise flow management
            let currentStep = 1; // Step 1: Shipping/Pickup selection, Step 2: Location selection

            // Create step containers
            const step1Container = document.createElement("div");
            step1Container.className = "popup-step-container";
            step1Container.id = "popup-step-1";
            step1Container.style.display = "block";

            const step2Container = document.createElement("div");
            step2Container.className = "popup-step-container";
            step2Container.id = "popup-step-2";
            step2Container.style.display = "none";

            // Add Shipping/Pickup toggle buttons to Step 1
            const shippingPickupContainer = document.createElement("div");
            shippingPickupContainer.className = "pickup-shipping-container";
            shippingPickupContainer.style.display = "flex";
            shippingPickupContainer.style.gap = "10px";
            shippingPickupContainer.style.padding = "15px";
            shippingPickupContainer.style.justifyContent = "center";

            step1Container.appendChild(shippingPickupContainer);
            popupContent.appendChild(step1Container);
            popupContent.appendChild(step2Container);

            // Locale-aware labels for Shipping and Pickup
            const shippingPickupText = {
                en: { SHIPPING: "Shipping", PICKUP: "Pickup" },
                es: { SHIPPING: "Envío a domicilio", PICKUP: "Retiro en tienda" },
                fr: { SHIPPING: "Livraison", PICKUP: "Retrait" },
                de: { SHIPPING: "Versand", PICKUP: "Abholung" },
                it: { SHIPPING: "Spedizione", PICKUP: "Ritiro" },
                pt: { SHIPPING: "Envio", PICKUP: "Retirada" },
                nl: { SHIPPING: "Verzending", PICKUP: "Afhalen" },
                ja: { SHIPPING: "配送", PICKUP: "店頭受取" },
                zh: { SHIPPING: "配送", PICKUP: "自提" },
                ru: { SHIPPING: "Доставка", PICKUP: "Самовывоз" }
            };

            const getPreferredLocale = () => {
                let localeStr = 'en';
                if (typeof window.Shopify !== 'undefined' && window.Shopify.locale) {
                    localeStr = window.Shopify.locale;
                } else if (typeof navigator !== 'undefined' && navigator.language) {
                    localeStr = navigator.language;
                }
                const base = String(localeStr).toLowerCase().split('-')[0];
                return shippingPickupText[base] ? base : 'en';
            };

            const t = (key) => {
                const locale = getPreferredLocale();
                return (shippingPickupText[locale] && shippingPickupText[locale][key]) || shippingPickupText.en[key];
            };

            const shiplabel = document.createElement("label");
            shiplabel.className = "pickup-shipping-label";
            shiplabel.classList.add("shipping");
            if (localStorage.getItem('multiloca_custom_key') === 'versand') {
                shiplabel.classList.add("active");
            }
            shiplabel.innerText = "🚚 Versandshop";
            shiplabel.classList.add("disabled");
            shiplabel.setAttribute("aria-disabled", "true");
            shiplabel.style.cursor = "default";
            shiplabel.style.pointerEvents = "none";
            shiplabel.style.padding = "10px 20px";
            shiplabel.style.border = "1px solid #ccc";
            shiplabel.style.borderRadius = "4px";
            shiplabel.style.color = "#6b6b6b"; 
            shiplabel.style.backgroundColor = "transparent";
            shiplabel.style.userSelect = "none";


            const picklabel = document.createElement("label");
            picklabel.className = "pickup-shipping-label";
            picklabel.classList.add("pickup");
            if (localStorage.getItem('multiloca_custom_key') === 'abholung') {
                picklabel.classList.add("active");
            }
            picklabel.innerText = "📍Abholshop";
            picklabel.style.cursor = "pointer";
            picklabel.style.padding = "10px 20px";
            picklabel.style.border = "1px solid #ccc";
            picklabel.style.borderRadius = "4px";
            picklabel.style.borderRadius = "4px";
            picklabel.style.color = "#fff";
            picklabel.style.backgroundColor = "#F05611";
            picklabel.style.userSelect = "none";

            shippingPickupContainer.appendChild(shiplabel);
            shippingPickupContainer.appendChild(picklabel);

            // Step navigation functions
            function goToStep(step) {
                if (step === 1) {
                    step1Container.style.display = "block";
                    step2Container.style.display = "none";
                    descriptionpopup.style.display = "none"; // Hide description in step 1
                    backButton.style.display = "none"; // Hide back button in step 1
                    currentStep = 1;
                } else if (step === 2) {
                    step1Container.style.display = "none";
                    step2Container.style.display = "block";
                    descriptionpopup.style.display = "block"; // Show description in step 2
                    backButton.style.display = "block"; // Show back button in step 2
                    currentStep = 2;
                }
            }

            // Add click event listener to back button
            backButton.addEventListener("click", function () {
                goToStep(1);
            });

            // Shop Now button will be appended after location container (at the bottom)

            // Function to refresh location data based on multilocaCustomKey
            async function refreshLocationData(multilocaCustomKey) {
                try {
                    const shopdomain = window.Shopify?.shop || window.location.hostname;
                    const locale = window.Shopify?.locale || 'en';
                    const market = window.Shopify?.market || '';
                    const customerEnterPincode = localStorage.getItem('customerEnterPincode') || '';
                    const customerEnterAddress = localStorage.getItem('customerEnterAddress') || '';

                    const url = `https://multiloca.info/api/get-loc-inventory-stock?shopdomain=${encodeURIComponent(shopdomain)}&variant_id=0&locale=${encodeURIComponent(locale)}&fromgeoblock=true&product_id=0&market=${encodeURIComponent(market)}&customerEnterPincode=${encodeURIComponent(customerEnterPincode)}&customerEnterAddress=${encodeURIComponent(customerEnterAddress)}&multilocaCustomKey=${encodeURIComponent(multilocaCustomKey)}`;
                    const result = await fetch(url, {
                        method: 'GET',
                    });

                    if (!result.ok) {
                        throw new Error(`HTTP error! Status: ${result.status}`);
                    }

                    const data = await result.json();

                    // Try to get locationarr from different possible locations in the response
                    // The API might return it as data.locationarr, data.settings.locations_arr, or data.settings.locationarr
                    let locationarr = null;
                    if (data?.locationarr && Array.isArray(data.locationarr)) {
                        locationarr = data.locationarr;
                    } else if (data?.settings?.locations_arr && Array.isArray(data.settings.locations_arr)) {
                        locationarr = data.settings.locations_arr;
                    } else if (data?.settings?.locationarr && Array.isArray(data.settings.locationarr)) {
                        locationarr = data.settings.locationarr;
                    }

                    // Update window.locationPopupData with new location data
                    if (locationarr && Array.isArray(locationarr)) {
                        // Get fresh saved location ID from localStorage
                        const currentSavedLocationId = localStorage.getItem("selected_location");

                        // Ensure window.locationPopupData exists before updating
                        if (!window.locationPopupData) {
                            window.locationPopupData = {};
                        }

                        // Update the global location data
                        window.locationPopupData.locationarr = locationarr;
                        console.log("locationarr", locationarr);

                        // Get the container from DOM to ensure we have the correct reference
                        let containerToUpdate = locationContainer;
                        if (!containerToUpdate || !containerToUpdate.parentNode) {
                            // Fallback: try to find container by class name within the popup
                            const popup = document.getElementById("multiloca-locationPopup");
                            if (popup) {
                                if (locationPopupstyle === "dropdown") {
                                    containerToUpdate = popup.querySelector("#locationDropDown") || popup.querySelector('.multiloca-popup-location-dropdown-popup');
                                } else if (locationPopupstyle === "cards") {
                                    containerToUpdate = popup.querySelector('.multiloca-popup-location-grid');
                                } else if (locationPopupstyle === 'list') {
                                    containerToUpdate = popup.querySelector('.multiloca-popup-location-list');
                                } else if (locationPopupstyle === 'inline-list') {
                                    containerToUpdate = popup.querySelector('.multiloca-popup-location-inline');
                                }
                            }
                        }

                        if (!containerToUpdate) {
                            console.error('❌ Location container not found!', {
                                locationPopupstyle,
                                hasLocationContainer: !!locationContainer,
                                popupExists: !!document.getElementById("multiloca-locationPopup")
                            });
                            return;
                        }

                        // Update the closure variable to keep reference in sync
                        locationContainer = containerToUpdate;

                        // Clear existing location container completely
                        containerToUpdate.innerHTML = '';
                        if (locationPopupstyle === "dropdown") {
                            const defaultOption = document.createElement("option");
                            defaultOption.value = '';
                            defaultOption.textContent = 'WÄHLE DEINEN STANDORT';
                            containerToUpdate.appendChild(defaultOption);
                        }

                        // Re-populate location container with new data
                        const fragment = document.createDocumentFragment();
                        locationarr.forEach(location => {
                            const locationId = location?.node ? location?.node?.id?.split('/').pop() : location?.id?.split('/').pop();
                            const locationName = location?.node ? location?.node?.name : location?.name;

                            if (locationPopupstyle === "dropdown") {
                                const option = document.createElement("option");
                                option.value = locationId;
                                option.textContent = locationName;
                                if (currentSavedLocationId === locationId) {
                                    option.selected = true;
                                }
                                fragment.appendChild(option);
                            }
                            if (locationPopupstyle === "cards") {
                                const item = document.createElement("div");
                                item.className = "multiloca-popup-location-item";
                                item.dataset.locationId = locationId;
                                item.textContent = locationName;
                                if (currentSavedLocationId === locationId) {
                                    item.classList.add("selected");
                                }
                                fragment.appendChild(item);
                            }
                            if (locationPopupstyle === 'list') {
                                const item = document.createElement("div");
                                item.className = "multiloca-popup-location-item";
                                item.dataset.locationId = locationId;
                                const nameElement = document.createElement("div");
                                nameElement.className = "multiloca-popup-location-name";
                                nameElement.textContent = locationName;
                                item.appendChild(nameElement);
                                if (currentSavedLocationId === locationId) {
                                    item.classList.add("selected");
                                }
                                fragment.appendChild(item);
                            }
                            if (locationPopupstyle === 'inline-list') {
                                const item = document.createElement("div");
                                item.className = "multiloca-popup-location-item";
                                item.dataset.locationId = locationId;
                                item.textContent = locationName;
                                if (currentSavedLocationId === locationId) {
                                    item.classList.add("selected");
                                }
                                fragment.appendChild(item);
                                locationPopup.style.width = "auto";
                            }
                        });

                        // Append all items at once for better performance
                        containerToUpdate.appendChild(fragment);

                        // Force immediate DOM update and repaint
                        void containerToUpdate.offsetHeight;
                        containerToUpdate.style.display = containerToUpdate.style.display || '';

                        // Use event delegation on container for better performance and reliability
                        // Remove any existing click handler first (if we stored it)
                        if (containerToUpdate._locationClickHandler) {
                            containerToUpdate.removeEventListener('click', containerToUpdate._locationClickHandler);
                        }

                        // Create and store the handler
                        containerToUpdate._locationClickHandler = function (e) {
                            const item = e.target.closest('.multiloca-popup-location-item');
                            if (item && locationPopupstyle !== "dropdown") {
                                const selectedLocationId = item.dataset.locationId;
                                containerToUpdate.querySelectorAll('.multiloca-popup-location-item').forEach(i => {
                                    i.classList.remove('selected');
                                });
                                item.classList.add('selected');
                            }
                        };

                        // Attach event delegation listener
                        if (locationPopupstyle !== "dropdown") {
                            containerToUpdate.addEventListener('click', containerToUpdate._locationClickHandler);
                        }

                        // Navigate to step 2 after loading locations
                        goToStep(2);
                    } else {
                        console.warn('⚠️ API response missing locationarr. Checked locations:', {
                            'data.locationarr': data?.locationarr,
                            'data.settings.locations_arr': data?.settings?.locations_arr,
                            'data.settings.locationarr': data?.settings?.locationarr,
                            'fullResponse': data
                        });
                    }
                } catch (error) {
                    console.error('Error refreshing location data:', error);
                }
            }

       
            shiplabel.addEventListener("click", async function () {
                // ignore clicks when disabled
                if (shiplabel.classList.contains("disabled")) return;
                shiplabel.classList.add("active");
                picklabel.classList.remove("active");
                if (localStorage.getItem('multiloca_custom_key') === 'versand') {
                    // If already selected, just navigate to step 2
                    goToStep(2);
                    return;
                }
                localStorage.setItem('multiloca_custom_key', 'versand');
                locationContainer.style.display = "block";
                await refreshLocationData('versand');
            });

            picklabel.addEventListener("click", async function () {
                picklabel.classList.add("active");
                shiplabel.classList.remove("active");
                if (localStorage.getItem('multiloca_custom_key') === 'abholung') {
                    // If already selected, just navigate to step 2
                    goToStep(2);
                    return;
                }
                localStorage.setItem('multiloca_custom_key', 'abholung');
                locationContainer.style.display = "block";
                await refreshLocationData('abholung');
            });
        }


        locationarr.forEach(location => {
            const locationId = location?.node ? location?.node?.id?.split('/').pop() : location?.id?.split('/').pop();
            const locationName = location?.node ? location?.node?.name : location?.name;

            if (locationPopupstyle === "dropdown") {
                const option = document.createElement("option");
                option.value = locationId;
                option.textContent = locationName;
                if (savedLocationId === locationId) {
                    option.selected = true;
                }
                locationContainer.appendChild(option);
            }
            if (locationPopupstyle === "cards") {
                const item = document.createElement("div");
                item.className = "multiloca-popup-location-item";
                item.dataset.locationId = locationId;
                item.textContent = locationName;
                if (savedLocationId === locationId) {
                    item.classList.add("selected");
                }
                locationContainer.appendChild(item);
            }
            if (locationPopupstyle === 'list') {
                const item = document.createElement("div");
                item.className = "multiloca-popup-location-item";
                item.dataset.locationId = locationId;
                const nameElement = document.createElement("div");
                nameElement.className = "multiloca-popup-location-name";
                nameElement.textContent = locationName;
                item.appendChild(nameElement);
                if (savedLocationId === locationId) {
                    item.classList.add("selected");
                }
                locationContainer.appendChild(item);
            }
            if (locationPopupstyle === 'inline-list') {
                const item = document.createElement("div");
                item.className = "multiloca-popup-location-item";
                item.dataset.locationId = locationId;
                item.textContent = locationName;
                if (savedLocationId === locationId) {
                    item.classList.add("selected");
                }
                locationContainer.appendChild(item);
                locationPopup.style.width = "auto";
            }

        });

        popupContent.appendChild(locationContainer);

        async function handleLocationSelection(locationId) {
            // Get settings from the main inventory data
            const purchaseFromOneLocation = window.locationPopupData?.purchaseFromOneLocation || 'false';
            const purchaseOneLocationToast = window.locationPopupData?.purchaseOneLocationToast || 'Items you are purchasing are availabe at the location you are choosing. Are you sure you want to switch location.';
            const someProductAvailableMessage = window.locationPopupData?.someProductAvailableMessage || 'The following items in your cart are not available at Selected location. You can remove unavailable items from your cart and continue...';
            
            const previosLocationid = localStorage.getItem("selected_location");
            
            if (purchaseFromOneLocation == 'true') {
                if (previosLocationid && previosLocationid !== locationId) {
                    const existingCartResponse = await fetch(`/cart.js`);
                    const existingCartData = await existingCartResponse.json();
                    const existingNoteAttributes = existingCartData.attributes || {};
                    let locationNotesAttribute = existingNoteAttributes['location_notes'];

                    if (existingCartData.items.length == 0) {
                        locationNotesAttribute = '';
                    }

                    if (!locationNotesAttribute) {
                        executeLocationChange();
                    } else {
                        const existingNotes = locationNotesAttribute;
                        const existingLocationIds = existingNotes.split(',').map(item => item.split(':')[1]);

                        if (existingCartData.items.length != 0) {
                            if (existingLocationIds.length > 0) {
                                if (!existingLocationIds.includes(locationId)) {
                                    const pendingLocationData = locationarr.find(location => location.node.id.split('/').pop() === locationId);
                                    const shopdomain = window.Shopify?.shop || window.location.hostname;
                                    window.multilocation.showToast(purchaseOneLocationToast, locationId, pendingLocationData, shopdomain, someProductAvailableMessage, executeLocationChange);
                                    closeLocationPopup();
                                    return;
                                }
                            }
                        }
                    }
                }
            }
            
            executeLocationChange();
            
            function executeLocationChange() {
                localStorage.setItem("selected_location", locationId);
                // console.log("location update and dispatched");
                const matchingRadioButton = document.querySelector(`input[name="selected_location"][value="${locationId}"]`);
                if (matchingRadioButton) {
                    matchingRadioButton.checked = true;
                    if (locationSelectionType === 'colorinversion') {
                        const locationCard = matchingRadioButton.closest(".location-card-listview");
                        if (locationCard) {
                            // First remove any existing styles from all cards
                            const allLocationCards = document.querySelectorAll(".location-card-listview");
                            allLocationCards.forEach(card => {
                                card.style.removeProperty('background-color');
                                card.style.removeProperty('color');
                            });
                            // Then set the styles for the selected card
                            locationCard.style.backgroundColor = "rgb(var(--color-foreground))";
                            locationCard.style.color = "rgb(var(--color-background))";
                        }
                    }
                } else {
                    const allRadioButtons = document.querySelectorAll(`input[name="selected_location"]`);
                    allRadioButtons.forEach(radio => {
                        radio.checked = false;
                    });
                    const allLocationCards = document.querySelectorAll(".location-card-listview");
                    allLocationCards.forEach(card => {
                        card.style.removeProperty('background-color');
                        card.style.removeProperty('color');
                    });
                }

                // Update the header location name
                const locationshowonheader = document.getElementById("location-popup-header-id");
                let locationName = null;
                if (locationshowonheader) {
                    const selectedLocation = locationarr.find(location => location.node.id.split('/').pop() === locationId);
                    if (selectedLocation) {
                        locationName = selectedLocation?.node ? selectedLocation?.node?.name : selectedLocation?.name;
                        locationshowonheader.textContent = selectedLocation.node.name;
                    }
                } else {
                    const locationNamesDropDownselect = document.getElementById("locationNamesDropDownselect");
                    if (locationNamesDropDownselect) {
                        locationNamesDropDownselect.value = locationId;
                        const changeEvent = new Event('change', { bubbles: true });
                        locationNamesDropDownselect.dispatchEvent(changeEvent);
                    }
                }

                const event = new CustomEvent('locationChanged', {
                    detail: { locationId, locationName }
                });
                document.dispatchEvent(event);
                
                // Close the popup
                closeLocationPopup();
            }
            
            function closeLocationPopup() {
                const popup = document.getElementById("multiloca-locationPopup");
                const overlay = document.getElementById("multiloca-popup-overlay");
                if (popup) popup.remove();
                if (overlay) overlay.remove();
            }
        }

        if (locationPopupstyle === "dropdown") {
            locationContainer.addEventListener('change', function () {
                // Only visual selection, actual selection happens on Shop Now button click
            });
        } else {
            document.querySelectorAll('.multiloca-popup-location-item').forEach(item => {
                item.addEventListener('click', function () {
                    const selectedLocationId = this.dataset.locationId;

                    document.querySelectorAll('.multiloca-popup-location-item').forEach(i => {
                        i.classList.remove('selected');
                    });
                    this.classList.add('selected');

                    // Only visual selection, actual selection happens on Shop Now button click
                });
            });
        }

        shopNowButton.addEventListener('click', function () {
            let selectedLocationId = null;
            
            if (locationPopupstyle === "dropdown") {
                selectedLocationId = locationContainer.value;
            } else {
                const selectedItem = document.querySelector('.multiloca-popup-location-item.selected');
                if (selectedItem) {
                    selectedLocationId = selectedItem.dataset.locationId;
                }
            }
            
            if (selectedLocationId) {
                handleLocationSelection(selectedLocationId);
            } 
        });

        const openpopup = document.getElementById("multiloca-locationPopup");
        openpopup.style.display = "block";
        openpopup.style.animation = ".4s ease-out slideup-location-popup";
        document.getElementById("multiloca-popup-overlay").style.display = "block";

        closePopup.addEventListener("click", function () {
            const popup = document.getElementById("multiloca-locationPopup");
            const overlay = document.getElementById("multiloca-popup-overlay");
            if (popup) popup.remove();
            if (overlay) overlay.remove();
        });
    }

    // function sleep(ms) {
    //     console.log("testpopup");
    //     return new Promise(resolve => setTimeout(resolve, ms));
    // }
    // await sleep(3000);
    // const locationPopupData = window.locationPopupData;
    function waitForLocationPopupData(timeout = 8000, interval = 200) {
            return new Promise(resolve => {
                const start = Date.now();
                (function check() {
                    if (window.locationPopupData) return resolve(window.locationPopupData);
                    if (Date.now() - start >= timeout) return resolve(window.locationPopupData || null);
                    setTimeout(check, interval);
                })();
            });
        }

        const locationPopupData = await waitForLocationPopupData(8000, 200);

    if (!window.logsPrinted) {
        if (locationPopupData) {
            const locationarr = locationPopupData.locationarr;
            const locationPopup = locationPopupData.locationPopup;
            const locationPopupstyle = locationPopupData.locationPopupstyle;
            const locationSelectionType = locationPopupData.locationSelectionType;
            const locationPopupHeader = locationPopupData.locationPopupHeader;
            const locationPopupDescription = locationPopupData.locationPopupDescription;

            // console.log("Location Stock Data:", locationStockData);
            // console.log("Location Popup Data:", locationPopupData);

            const savedLocationId = localStorage.getItem("selected_location");

            if (locationPopup === "true" && savedLocationId === null) {
                // console.log("Location Popup is enabled");
                const multiloca_custom_key = localStorage.getItem("multiloca_custom_key");
                if(!multiloca_custom_key){
                    createpopup(locationarr, locationPopupstyle, locationSelectionType, locationPopupHeader, locationPopupDescription, savedLocationId);
                }

            }

            window.logsPrinted = true;
        } else {
            // console.error("Location Stock Data is not available.");
        }
    }
});

document.addEventListener("openLocationPopup", function () {

    const locationPopupData = window.locationPopupData;
    const locationarr = locationPopupData.locationarr;
    const locationPopupstyle = locationPopupData.locationPopupstyle;
    const locationSelectionType = locationPopupData.locationSelectionType;
    const locationPopupHeader = locationPopupData.locationPopupHeader;
    const locationPopupDescription = locationPopupData.locationPopupDescription;
    const PickeasyIntegration = locationPopupData.PickeasyIntegration || 'false';
    const savedLocationId = localStorage.getItem("selected_location");

    const existingPopup = document.getElementById("multiloca-locationPopup");
    const existingOverlay = document.getElementById("multiloca-popup-overlay");
    if (existingPopup) existingPopup.remove();
    if (existingOverlay) existingOverlay.remove();


        const overlay = document.createElement("div");
        overlay.id = "multiloca-popup-overlay";
        document.body.appendChild(overlay);

        const locationPopup = document.createElement("div");
        if (locationPopupstyle === 'list') {
            locationPopup.classList.add("vertical-list-popup");
        }
        locationPopup.id = "multiloca-locationPopup";
        document.body.appendChild(locationPopup);

        const popupHeader = document.createElement("div");
        popupHeader.className = "multiloca-popup-header";
        popupHeader.innerHTML = locationPopupHeader;
        locationPopup.appendChild(popupHeader);

        const closePopup = document.createElement("span");
        closePopup.id = "multiloca-closePopup";
        closePopup.classList.add("close-popup-button");
        closePopup.innerHTML = "&#10005;";
        popupHeader.appendChild(closePopup);

        const popupContent = document.createElement("div");
        popupContent.className = "multiloca-popup-content";
        locationPopup.appendChild(popupContent);

        const descriptionpopup = document.createElement("div");
        descriptionpopup.className = "popup-description";
        descriptionpopup.innerHTML = locationPopupDescription;
        popupContent.appendChild(descriptionpopup);

        let locationContainer;
        if (locationPopupstyle === "dropdown") {
            locationContainer = document.createElement("select");
            locationContainer.className = "multiloca-popup-location-dropdown-popup";
            locationContainer.id = "locationDropDown";
            locationContainer.innerHTML = "<option value=''>WÄHLE DEINEN STANDORT</option>";
        }
        if (locationPopupstyle === "cards") {
            locationContainer = document.createElement("div");
            locationContainer.className = "multiloca-popup-location-grid";
        }
        if (locationPopupstyle === 'list') {
            locationContainer = document.createElement("div");
            locationContainer.className = "multiloca-popup-location-list";
            
        }
        if (locationPopupstyle === 'inline-list') {
            locationContainer = document.createElement("div");
            locationContainer.className = "multiloca-popup-location-inline";
        }


        locationarr.forEach(location => {
            const locationId = location?.node ? location?.node?.id?.split('/').pop() : location?.id?.split('/').pop();
            const locationName = location?.node ? location?.node?.name : location?.name;

            if (locationPopupstyle === "dropdown") {
                const option = document.createElement("option");
                option.value = locationId;
                option.textContent = locationName;
                if (savedLocationId === locationId) {
                    option.selected = true;
                }
                locationContainer.appendChild(option);
            }
            if (locationPopupstyle === "cards") {
                const item = document.createElement("div");
                item.className = "multiloca-popup-location-item";
                item.dataset.locationId = locationId;
                item.textContent = locationName;
                if (savedLocationId === locationId) {
                    item.classList.add("selected");
                }
                locationContainer.appendChild(item);
            }
            if (locationPopupstyle === 'list') {
                const item = document.createElement("div");
                item.className = "multiloca-popup-location-item";
                item.dataset.locationId = locationId;
                const nameElement = document.createElement("div");
                nameElement.className = "multiloca-popup-location-name";
                nameElement.textContent = locationName;
                item.appendChild(nameElement);
                if (savedLocationId === locationId) {
                    item.classList.add("selected");
                }
                locationContainer.appendChild(item);
            }
            if (locationPopupstyle === 'inline-list') {
                const item = document.createElement("div");
                item.className = "multiloca-popup-location-item";
                item.dataset.locationId = locationId;
                item.textContent = locationName;
                if (savedLocationId === locationId) {
                    item.classList.add("selected");
                }
                locationContainer.appendChild(item);
                locationPopup.style.width = "auto";
            }

        });

        popupContent.appendChild(locationContainer);

        async function handleLocationSelection(locationId) {
            const purchaseFromOneLocation = window.locationPopupData?.purchaseFromOneLocation || 'false';
            const purchaseOneLocationToast = window.locationPopupData?.purchaseOneLocationToast || 'Items you are purchasing are availabe at the location you are choosing. Are you sure you want to switch location.';
            const someProductAvailableMessage = window.locationPopupData?.someProductAvailableMessage || 'The following items in your cart are not available at Selected location. You can remove unavailable items from your cart and continue...';
            
            const previosLocationid = localStorage.getItem("selected_location");
            
            if (purchaseFromOneLocation == 'true') {
                if (previosLocationid && previosLocationid !== locationId) {
                    const existingCartResponse = await fetch(`/cart.js`);
                    const existingCartData = await existingCartResponse.json();
                    const existingNoteAttributes = existingCartData.attributes || {};
                    let locationNotesAttribute = existingNoteAttributes['location_notes'];

                    if (existingCartData.items.length == 0) {
                        locationNotesAttribute = '';
                    }

                    if (!locationNotesAttribute) {
                        executeLocationChange();
                    } else {
                        const existingNotes = locationNotesAttribute;
                        const existingLocationIds = existingNotes.split(',').map(item => item.split(':')[1]);

                        if (existingCartData.items.length != 0) {
                            if (existingLocationIds.length > 0) {
                                if (!existingLocationIds.includes(locationId)) {
                                    const pendingLocationData = locationarr.find(location => location.node.id.split('/').pop() === locationId);
                                    const shopdomain = window.Shopify?.shop || window.location.hostname;
                                    window.multilocation.showToast(purchaseOneLocationToast, locationId, pendingLocationData, shopdomain, someProductAvailableMessage, executeLocationChange);
                                    closeLocationPopup();
                                    return;
                                }
                            }
                        }
                    }
                }
            }
            
            executeLocationChange();
            
            function executeLocationChange() {
                localStorage.setItem("selected_location", locationId);
                // console.log("location update and dispatched");
                const matchingRadioButton = document.querySelector(`input[name="selected_location"][value="${locationId}"]`);
                if (matchingRadioButton) {
                    matchingRadioButton.checked = true;
                    if (locationSelectionType === 'colorinversion') {
                        const locationCard = matchingRadioButton.closest(".location-card-listview");
                        if (locationCard) {
                            // First remove any existing styles from all cards
                            const allLocationCards = document.querySelectorAll(".location-card-listview");
                            allLocationCards.forEach(card => {
                                card.style.removeProperty('background-color');
                                card.style.removeProperty('color');
                            });
                            // Then set the styles for the selected card
                            locationCard.style.backgroundColor = "rgb(var(--color-foreground))";
                            locationCard.style.color = "rgb(var(--color-background))";
                        }
                    }
                } else {
                    const allRadioButtons = document.querySelectorAll(`input[name="selected_location"]`);
                    allRadioButtons.forEach(radio => {
                        radio.checked = false;
                    });
                    const allLocationCards = document.querySelectorAll(".location-card-listview");
                    allLocationCards.forEach(card => {
                        card.style.removeProperty('background-color');
                        card.style.removeProperty('color');
                    });
                }

                // Update the header location name
                const locationshowonheader = document.getElementById("location-popup-header-id");
                let locationName = null;
                if (locationshowonheader) {
                    const selectedLocation = locationarr.find(location => location.node.id.split('/').pop() === locationId);
                    if (selectedLocation) {
                        locationName = selectedLocation?.node ? selectedLocation?.node?.name : selectedLocation?.name;
                        locationshowonheader.textContent = selectedLocation.node.name;
                    }
                } else {
                    const locationNamesDropDownselect = document.getElementById("locationNamesDropDownselect");
                    if (locationNamesDropDownselect) {
                        locationNamesDropDownselect.value = locationId;
                    }

                    const changeEvent = new Event('change', { bubbles: true });
                    locationNamesDropDownselect.dispatchEvent(changeEvent);
                }
                window.multilocation.updateCollectionInventory();

                const event = new CustomEvent('locationChanged', {
                    detail: { locationId, locationName }
                });
                document.dispatchEvent(event);
                
                // Close the popup
                closeLocationPopup();
                if(PickeasyIntegration === 'true' || PickeasyIntegration === true){
                    const selectedLocation = locationarr.find(location => location.node.id.split('/').pop() === locationId);
                    const locationName = selectedLocation?.node ? selectedLocation?.node?.name : selectedLocation?.name;
                    const pickupLocations = document.querySelectorAll('.pickup-location');
                    if(pickupLocations.length > 0){
                        pickupLocations.forEach(loc => {
                            const label = loc.querySelector('label');
                            if (label) {
                                if(label.textContent.trim() === locationName.trim()){
                                    const radio = loc.querySelector('input[type="radio"]');
                                    if(radio){
                                        radio.checked = true;
                                        radio.dispatchEvent(new Event('change', { bubbles: true }));
                                    }
                                }
                            }
                        });
                    }
                }

            }
            
            function closeLocationPopup() {
                const popup = document.getElementById("multiloca-locationPopup");
                const overlay = document.getElementById("multiloca-popup-overlay");
                if (popup) popup.remove();
                if (overlay) overlay.remove();
            }
        }

        if (locationPopupstyle === "dropdown") {
            locationContainer.addEventListener('change', function () {
                const selectedLocationId = this.value;
                if (selectedLocationId) {
                    handleLocationSelection(selectedLocationId);
                }
            });
        } else {
            document.querySelectorAll('.multiloca-popup-location-item').forEach(item => {
                item.addEventListener('click', function () {
                    const selectedLocationId = this.dataset.locationId;

                    document.querySelectorAll('.multiloca-popup-location-item').forEach(i => {
                        i.classList.remove('selected');
                    });
                    this.classList.add('selected');

                    handleLocationSelection(selectedLocationId);
                });
            });
        }


        const openpopup = document.getElementById("multiloca-locationPopup");
        openpopup.style.display = "block";
        openpopup.style.animation = ".4s ease-out slideup-location-popup";
        document.getElementById("multiloca-popup-overlay").style.display = "block";

        closePopup.addEventListener("click", function () {
            const popup = document.getElementById("multiloca-locationPopup");
            const overlay = document.getElementById("multiloca-popup-overlay");
            if (popup) popup.remove();
            if (overlay) overlay.remove();
        });
});
